import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import RanDBUploadFormComponent from './ran_db_upload_form.component';
import { useSetAtom } from 'jotai';
import { openUploadFormRanDb, selectedRanDbRow } from '../../common/atom/atoms';
export const RanDBUploadForm = () => {
  const setOpenUploadForm = useSetAtom(openUploadFormRanDb);
  const setSelectedRow = useSetAtom(selectedRanDbRow);

  const handleBackClick = () => {
    setOpenUploadForm(false);
    setSelectedRow(null);
  };

  return (
    <div style={{ width: '100%', padding: '20px 2%', backgroundColor: '#fff' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div
            style={{
              padding: 8,
              background: '#f7f7f7',
              boxShadow: '0px 0px 30px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: 8,
              height: 30,
              width: 30,
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={handleBackClick}
          >
            <ArrowBackIosNewIcon style={{ fontSize: 18, color: '#1C274C' }} />
          </div>
          <div style={{ color: 'black', fontSize: 20, fontWeight: '500', wordWrap: 'break-word' }}>
            Update
          </div>
        </div>
      </div>
      <RanDBUploadFormComponent />
    </div>
  );
};
